import React from 'react';
import SignupLivePreview from './Onboarding/SignupLivePreview';
import { readSignupOrgName } from './Onboarding/signupOrgNameStorage';
import './stylesheet/customLogin.css';
import './Onboarding/signupLivePreview.css';

export default function AuthPreviewLayout({
  children,
  orgName,
  username,
  workEmail,
  focusedField,
}) {
  const resolvedOrgName = orgName || readSignupOrgName() || undefined;

  return (
    <div className="auth-layout auth-layout--with-preview">
      <div className="auth-form-panel">{children}</div>
      <SignupLivePreview
        orgName={resolvedOrgName}
        username={username}
        workEmail={workEmail}
        focusedField={focusedField}
      />
    </div>
  );
}
